import BatteryPacks from './BatteryPacks';

export default BatteryPacks;
